<template>
    <tr
        :class="rowClasses(row._index)"
        :draggable="draggable"
        @dragstart="onDrag($event, row._index)"
        @drop="onDrop($event, row._index)"
        @dragover="allowDrop($event)"
        v-if="draggable"
    >
        <slot></slot>
    </tr>
    <tr :class="rowClasses(row._index)" :draggable="false" v-else>
        <slot></slot>
    </tr>
</template>
<script>
export default {
    inject: ['tableRoot'],
    props: {
        row: Object,
        prefixCls: String,
        draggable: Boolean,
        isChildren: Boolean // 开启后，会认为是子节点，相关逻辑通过 rowKey 查找
    },
    computed: {
        objData() {
            return this.$parent.objData;
        }
    },
    methods: {
        onDrag(e, index) {
            e.dataTransfer.setData('index', index);
        },
        onDrop(e, index) {
            const dragIndex = e.dataTransfer.getData('index');
            this.$parent.$parent.$parent.$parent.dragAndDrop(dragIndex, index);
            e.preventDefault();
        },
        allowDrop(e) {
            e.preventDefault();
        },
        rowClasses(_index) {
            const objData = this.isChildren
                ? this.$parent.$parent.$parent.$parent.getDataByRowKey(this.row._rowKey)
                : this.objData[_index];

            return [
                `${this.prefixCls}-row`,
                this.rowClsName(_index),
                {
                    [`${this.prefixCls}-row-highlight`]: objData && objData._isHighlight,
                    [`${this.prefixCls}-row-hover`]: objData && objData._isHover,
                    'row-tree-active': objData._isShowChildren,
                    'row-children': '_isShowChildren' in objData && !objData.children
                }
            ];
        },
        rowClsName(_index) {
            return this.tableRoot.rowClassName(this.objData[_index], _index);
        }
    }
};
</script>

<style lang="less" scoped>
.row-tree-active {
    /deep/ td {
        background-color: #ecf2f9;
    }
}
.row-children {
    /deep/ td {
        background-color: #f8faff;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/table/table-tr.vue